module.exports = __webpack_public_path__ + "img/7house08.4cbc1f36.jpg";